import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function CategorySection() {
  return (
    <section className="w-full border-y border-background-200 bg-background-100 py-12 md:py-16">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="max-w-2xl">
          <span className="flex items-center gap-2 text-xs font-medium tracking-wide text-accent-700">
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-layout-grid-line text-base" />
            </span>
            主题分类
          </span>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            找到你想围观的那块瓜田
          </h2>
          <p className="mt-2 text-sm text-foreground-600">
            六大话题方向，各有各的热闹。挑一个感兴趣的领域，从分类页进入，按最新或最热排序慢慢看。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col rounded-card border border-background-200 bg-background-50 p-5 transition-colors hover:border-accent-300"
            >
              <div className="flex items-center justify-between">
                <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-accent-100 text-accent-700 transition-colors group-hover:bg-accent-500 group-hover:text-background-50">
                  <i className={`${cat.icon} text-xl`} />
                </span>
                <span className="flex items-center gap-1 text-xs text-foreground-500">
                  <span className="flex h-3.5 w-3.5 items-center justify-center">
                    <i className="ri-chat-3-line text-sm" />
                  </span>
                  {cat.count} 个话题
                </span>
              </div>
              <h3 className="mt-4 text-base font-bold text-foreground-950">{cat.name}</h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{cat.desc}</p>
              <span className="mt-4 flex items-center gap-1 text-sm font-medium text-primary-600">
                进入分类
                <span className="flex h-4 w-4 items-center justify-center transition-transform group-hover:translate-x-1">
                  <i className="ri-arrow-right-line text-base" />
                </span>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}